import type { Dict } from '../utils'

import { createContext } from '../utils'

const [SidemenuProvider, useSidemenuContext] = createContext<Dict>({ isOptional: true })

export { SidemenuProvider, useSidemenuContext }
